module.exports = __webpack_public_path__ + "img/revamp-balance-background.b743b06a.png";